import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup-addon" }

import { computed, defineAsyncComponent, ref, watch } from "vue";
import { useDeleteStock } from "@/graphql/stock/delete.stock";
import { useUpdateQuantities } from "@/graphql/stock/update.quantities";
import { activeActivity } from "@/plugins/i18n";
import { Product } from "@/graphql/types";
import { useStockPermissions } from "@/hooks/permissions/useStockPermission";


export default /*#__PURE__*/_defineComponent({
  __name: 'StockTable',
  props: {
    product: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const UpdateStock = defineAsyncComponent(() => import("./UpdateStock.vue"));
const NewStock = defineAsyncComponent(() => import("./NewStock.vue"));

const emit = __emit;
const props = __props;

const addDialog = ref(false);
const { canDelete, canUpdate } = useStockPermissions();
const currency = activeActivity.value.currencySymbol;
const {
  qLoading,
  updateQuantities,
  editingRows,
  openConfirmStock,
  confirm_stock,
  confirmStock,
  dialog,
} = useUpdateQuantities(() => emit("update:modelValue", false));
const { removeLoading, deleteStock } = useDeleteStock();
const cannotUpdate = computed(() => !canUpdate || qLoading.value);
const cannotDelete = computed(() => !canDelete || removeLoading.value);
const cannotCreate = computed(() => !canDelete || qLoading.value);

function openDialog(stock: any) {
  if (stock) {
    dialog.show = true;
    dialog.stock = stock;
  } else addDialog.value = true;
  emit("update:modelValue", false);
}
watch(
  () => props.product.stocks,
  (stocks) => {
    editingRows.value = stocks.map((s) => ({
      id: s.id,
      nq: s.quantity,
      cq: s.quantity,
    }));
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
      header: _ctx.$t('stock.list', { name: _ctx.product.name }),
      closable: "",
      visible: _ctx.modelValue
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _unref(updateQuantities),
          loading: _unref(qLoading),
          disabled: cannotUpdate.value,
          icon: "pi pi-save",
          label: _ctx.$t('stock.update.save'),
          class: "p-m-0"
        }, null, 8, ["onClick", "loading", "disabled", "label"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm",
          value: _ctx.product.stocks,
          rows: _ctx.product.stocks.length,
          responsiveLayout: "scroll",
          "show-gridlines": ""
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openDialog(null))),
              icon: "pi pi-plus",
              label: _ctx.$t('stock.newEntry.title')
            }, null, 8, ["label"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "purchasePrice",
              header: _ctx.$t('stock.purchasePrice'),
              "sort-field": "purchasePrice",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.purchasePrice
                }, null, 8, ["value"]),
                _createTextVNode(" " + _toDisplayString(_unref(currency)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "inclTax",
              header: _ctx.$t('stock.sellingPrice'),
              sortable: true,
              "sort-field": "inclTax"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.inclTax
                }, null, 8, ["value"]),
                _createTextVNode(" " + _toDisplayString(_unref(currency)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "quantity",
              header: _ctx.$t('stock.quantity'),
              sortable: true,
              "sort-field": "quantity"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_InputNumber, {
                  style: {"height":"30px"},
                  modelValue: _unref(editingRows)[slotProps.index].nq,
                  "onUpdate:modelValue": ($event: any) => ((_unref(editingRows)[slotProps.index].nq) = $event),
                  showButtons: "",
                  buttonLayout: "horizontal",
                  decrementButtonClass: "p-button-danger addon",
                  incrementButtonClass: "p-button-success addon",
                  incrementButtonIcon: "pi pi-plus",
                  decrementButtonIcon: "pi pi-minus",
                  mode: "decimal",
                  "input-style": "max-width: 100px",
                  "max-fraction-digits": 20
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "expiredAt",
              header: _ctx.$t('stock.expiredAt'),
              sortable: true,
              "sort-field": "expiredAt"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.expiredAt && _ctx.$d(data.expiredAt)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "alertAt",
              header: _ctx.$t('stock.alertAt'),
              sortable: true,
              "sort-field": "alertAt"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.alertAt && _ctx.$d(data.alertAt)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "note",
              header: _ctx.$t('payment.note'),
              sortable: true,
              "sort-field": "note"
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              "body-class": "p-text-center",
              header: _ctx.$t('controls'),
              headerStyle: "width:12rem"
            }, {
              body: _withCtx(({ index, data }) => [
                _createVNode(_component_Button, {
                  class: "p-button-sm p-button-text p-mx-1",
                  icon: "pi pi-pencil",
                  onClick: ($event: any) => (openDialog(data)),
                  disabled: cannotUpdate.value
                }, null, 8, ["onClick", "disabled"]),
                (_ctx.product.stocks.length > 1)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-sm p-button-danger p-button-text p-mx-1",
                      icon: "pi pi-trash",
                      disabled: cannotDelete.value,
                      onClick: ($event: any) => (_unref(deleteStock)(data.id, _ctx.product.id))
                    }, null, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  class: "p-button-sm p-button-danger p-button-text p-mx-1",
                  icon: "pi pi-minus",
                  id: "minus_stock",
                  onClick: ($event: any) => (_unref(openConfirmStock)($event, index, data)),
                  "aria-controls": "overlay_panel",
                  disabled: cannotUpdate.value
                }, null, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  id: "add_stock",
                  disabled: cannotCreate.value,
                  "aria-controls": "overlay_panel",
                  class: "p-button-sm p-button-success p-button-text",
                  icon: "pi pi-plus",
                  onClick: ($event: any) => (_unref(openConfirmStock)($event, index, data))
                }, null, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value", "rows"])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    (_unref(dialog).show)
      ? (_openBlock(), _createBlock(_unref(UpdateStock), {
          key: 0,
          modelValue: _unref(dialog).show,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).show) = $event)),
            _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', !$event)))
          ],
          stock: _unref(dialog).stock,
          productName: _ctx.product.name
        }, null, 8, ["modelValue", "stock", "productName"]))
      : _createCommentVNode("", true),
    (addDialog.value)
      ? (_openBlock(), _createBlock(_unref(NewStock), {
          key: 1,
          modelValue: addDialog.value,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((addDialog).value = $event)),
            _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:modelValue', !$event)))
          ],
          productId: _ctx.product.id,
          productName: _ctx.product.name
        }, null, 8, ["modelValue", "productId", "productName"]))
      : _createCommentVNode("", true),
    (_unref(canUpdate))
      ? (_openBlock(), _createBlock(_component_OverlayPanel, {
          key: 2,
          ref_key: "confirm_stock",
          ref: confirm_stock,
          appendTo: "body",
          showCloseIcon: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_unref(confirmStock) && _unref(confirmStock)(...args)), ["prevent"])),
              class: "p-inputgroup"
            }, [
              _createElementVNode("span", _hoisted_1, [
                _createElementVNode("i", {
                  class: _normalizeClass(`pi pi-${_unref(dialog).sign > 0 ? 'plus' : 'minus'}`)
                }, null, 2)
              ]),
              _createVNode(_component_InputNumber, {
                min: 0,
                modelValue: _unref(dialog).quantity,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(dialog).quantity) = $event)),
                placeholder: _ctx.$t('stock.addQuantity')
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_Button, {
                class: _normalizeClass(`p-button-${_unref(dialog).sign > 0 ? 'success' : 'danger'}`),
                type: "submit",
                label: _ctx.$t('validate')
              }, null, 8, ["class", "label"])
            ], 32)
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})